/**
 * Tab containment for a modal dialog panel.
 */

export const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

/**
 * Keep Tab and Shift+Tab inside the panel. Focus outside the panel, or on an untabbable element ahead
 * of the first control or past the last one (a heading with tabindex="-1"), wraps to the far end.
 */
export function trapTabFocus(panel, event) {
    if (!panel) return;
    const items = [...panel.querySelectorAll(FOCUSABLE)].filter(el => el.offsetParent !== null);
    if (items.length === 0) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    const outside = !panel.contains(active);
    if (event.shiftKey && (active === first || outside || precedes(active, first))) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && (active === last || outside || precedes(last, active))) {
        event.preventDefault();
        first.focus();
    }
}

function precedes(a, b) {
    return a !== b && Boolean(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
}
